export default __webpack_public_path__ + "static/media/Group.b941fe08.svg";